// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.abyb {
  background: var(--c-cream);
  padding-block: var(--section-y);
  border-top: 1px solid var(--line);
  overflow: hidden;
}

.abyb__layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(3rem, 6vw, 6rem);
  align-items: start;
}

/* ── Left ── */
.abyb__left {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
}

/* Real plant image */
.abyb__plant {
  position: absolute;
  top: -1%;
  left: -4%;
  width: clamp(280px, 20vw, 230px);
  height: auto;
  opacity: 0.5;
  pointer-events: none;
  object-fit: contain;
}

.abyb__eyebrow {
  color: var(--accent) !important;
}

.abyb__headline {
  font-size: var(--fs-display);
  color: var(--c-forest);
  margin: var(--sp-2) 0 0;
}

.abyb__sub {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}

/* 2-col checklist grid */
.abyb__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 3vw, 2.5rem);
}

.abyb__item {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
}

.abyb__check {
  font-size: 1rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 2px;
}

.abyb__item-label {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--c-ink);
  margin: 0 0 var(--sp-1);
}

.abyb__item-sub {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-muted);
  margin: 0;
  line-height: var(--lh-snug);
}

/* ── Right: eligibility ── */
.abyb__elig {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(1.5rem, 2.5vw, 2.25rem);
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  background: var(--c-cream);
}

.abyb__elig-head {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.abyb__elig-shield {
  font-size: 1.15rem;
  color: var(--accent);
  flex-shrink: 0;
}

.abyb__elig-title {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  color: var(--accent);
  margin: 0;
}

.abyb__elig-intro {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}

/* Q row */
.abyb__q {
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: var(--sp-4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
}

.abyb__q-row {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  flex: 1 1;
}

.abyb__q-icon {
  font-size: 1rem;
  color: var(--accent);
  opacity: 0.7;
  flex-shrink: 0;
  margin-top: 2px;
}

.abyb__q-text {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--c-ink);
  line-height: var(--lh-body);
  margin: 0;
}

.abyb__q-btns {
  display: flex;
  gap: var(--sp-2);
  flex-shrink: 0;
}

.abyb__q-btn {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: 0.12em;
  padding: 0.45rem 0.85rem;
  border: 1.5px solid var(--line);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--c-ink);
  cursor: pointer;
  transition:
    background var(--dur) var(--ease),
    border-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}
.abyb__q-btn.active-yes {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-accent);
}
.abyb__q-btn.active-no {
  background: var(--c-ink);
  border-color: var(--c-ink);
  color: var(--c-cream);
}
.abyb__q-btn:hover:not(.active-yes):not(.active-no) {
  border-color: var(--accent);
  color: var(--accent);
}

/* Note */
.abyb__note {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
  background: rgba(27, 27, 27, 0.04);
  border-radius: var(--radius-sm);
  padding: var(--sp-4);
}
.abyb__note--crisis {
  background: rgba(168, 102, 66, 0.08);
  border: 1px solid rgba(168, 102, 66, 0.3);
}
.abyb__note svg {
  font-size: 1rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 2px;
}
.abyb__note p {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}
.abyb__note--crisis p {
  color: var(--c-ink);
}

@media (max-width: 991.98px) {
  .abyb__layout {
    grid-template-columns: 1fr;
  }
  .abyb__plant {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .abyb__grid {
    grid-template-columns: 1fr;
  }
}

/* ── Mobile font size fixes ── */
@media (max-width: 767.98px) {
  .abyb__headline {
    font-size: var(--fs-display);
  }
  .abyb__item-label {
    font-size: var(--fs-body);
  }
  .abyb__item-sub {
    font-size: var(--fs-sm);
  }
  .abyb__q-text {
    font-size: var(--fs-sm);
  }
  .abyb__note p {
    font-size: var(--fs-sm);
  }
}

/* ── Mobile design match ── */
@media (max-width: 767.98px) {
  .abyb {
    padding-block: var(--sp-8);
  }
  .abyb__eyebrow {
    font-size: var(--fs-sm);
  }
  .abyb__headline {
    font-size: clamp(2rem, 9vw, 3rem);
  }
  .abyb__sub {
    font-size: var(--fs-body);
  }
  .abyb__item-label {
    font-size: var(--fs-body);
    font-weight: 700;
  }
  .abyb__item-sub {
    font-size: var(--fs-sm);
  }
  .abyb__grid {
    gap: var(--sp-5) var(--sp-6);
  }
  .abyb__elig {
    padding: var(--sp-5);
  }
  .abyb__elig-title {
    font-size: var(--fs-body);
  }
  .abyb__elig-intro p {
    font-size: var(--fs-body);
  }
  .abyb__q-text p {
    font-size: var(--fs-body);
  }
  .abyb__q {
    flex-direction: column;
    align-items: flex-start;
  }
  .abyb__note p {
    font-size: var(--fs-body);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApplyBeforeYouBegin.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,UAAU;AACV;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf;;;gCAG8B;AAChC;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".abyb {\n  background: var(--c-cream);\n  padding-block: var(--section-y);\n  border-top: 1px solid var(--line);\n  overflow: hidden;\n}\n\n.abyb__layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: clamp(3rem, 6vw, 6rem);\n  align-items: start;\n}\n\n/* ── Left ── */\n.abyb__left {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-6);\n}\n\n/* Real plant image */\n.abyb__plant {\n  position: absolute;\n  top: -1%;\n  left: -4%;\n  width: clamp(280px, 20vw, 230px);\n  height: auto;\n  opacity: 0.5;\n  pointer-events: none;\n  object-fit: contain;\n}\n\n.abyb__eyebrow {\n  color: var(--accent) !important;\n}\n\n.abyb__headline {\n  font-size: var(--fs-display);\n  color: var(--c-forest);\n  margin: var(--sp-2) 0 0;\n}\n\n.abyb__sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n/* 2-col checklist grid */\n.abyb__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 3vw, 2.5rem);\n}\n\n.abyb__item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n}\n\n.abyb__check {\n  font-size: 1rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.abyb__item-label {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  color: var(--c-ink);\n  margin: 0 0 var(--sp-1);\n}\n\n.abyb__item-sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  margin: 0;\n  line-height: var(--lh-snug);\n}\n\n/* ── Right: eligibility ── */\n.abyb__elig {\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(1.5rem, 2.5vw, 2.25rem);\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-5);\n  background: var(--c-cream);\n}\n\n.abyb__elig-head {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n}\n\n.abyb__elig-shield {\n  font-size: 1.15rem;\n  color: var(--accent);\n  flex-shrink: 0;\n}\n\n.abyb__elig-title {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  color: var(--accent);\n  margin: 0;\n}\n\n.abyb__elig-intro {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n/* Q row */\n.abyb__q {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-4);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--sp-4);\n}\n\n.abyb__q-row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  flex: 1;\n}\n\n.abyb__q-icon {\n  font-size: 1rem;\n  color: var(--accent);\n  opacity: 0.7;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.abyb__q-text {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--c-ink);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n.abyb__q-btns {\n  display: flex;\n  gap: var(--sp-2);\n  flex-shrink: 0;\n}\n\n.abyb__q-btn {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  padding: 0.45rem 0.85rem;\n  border: 1.5px solid var(--line);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--c-ink);\n  cursor: pointer;\n  transition:\n    background var(--dur) var(--ease),\n    border-color var(--dur) var(--ease),\n    color var(--dur) var(--ease);\n}\n.abyb__q-btn.active-yes {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--on-accent);\n}\n.abyb__q-btn.active-no {\n  background: var(--c-ink);\n  border-color: var(--c-ink);\n  color: var(--c-cream);\n}\n.abyb__q-btn:hover:not(.active-yes):not(.active-no) {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Note */\n.abyb__note {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--sp-3);\n  background: rgba(27, 27, 27, 0.04);\n  border-radius: var(--radius-sm);\n  padding: var(--sp-4);\n}\n.abyb__note--crisis {\n  background: rgba(168, 102, 66, 0.08);\n  border: 1px solid rgba(168, 102, 66, 0.3);\n}\n.abyb__note svg {\n  font-size: 1rem;\n  color: var(--accent);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.abyb__note p {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n.abyb__note--crisis p {\n  color: var(--c-ink);\n}\n\n@media (max-width: 991.98px) {\n  .abyb__layout {\n    grid-template-columns: 1fr;\n  }\n  .abyb__plant {\n    display: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .abyb__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Mobile font size fixes ── */\n@media (max-width: 767.98px) {\n  .abyb__headline {\n    font-size: var(--fs-display);\n  }\n  .abyb__item-label {\n    font-size: var(--fs-body);\n  }\n  .abyb__item-sub {\n    font-size: var(--fs-sm);\n  }\n  .abyb__q-text {\n    font-size: var(--fs-sm);\n  }\n  .abyb__note p {\n    font-size: var(--fs-sm);\n  }\n}\n\n/* ── Mobile design match ── */\n@media (max-width: 767.98px) {\n  .abyb {\n    padding-block: var(--sp-8);\n  }\n  .abyb__eyebrow {\n    font-size: var(--fs-sm);\n  }\n  .abyb__headline {\n    font-size: clamp(2rem, 9vw, 3rem);\n  }\n  .abyb__sub {\n    font-size: var(--fs-body);\n  }\n  .abyb__item-label {\n    font-size: var(--fs-body);\n    font-weight: 700;\n  }\n  .abyb__item-sub {\n    font-size: var(--fs-sm);\n  }\n  .abyb__grid {\n    gap: var(--sp-5) var(--sp-6);\n  }\n  .abyb__elig {\n    padding: var(--sp-5);\n  }\n  .abyb__elig-title {\n    font-size: var(--fs-body);\n  }\n  .abyb__elig-intro p {\n    font-size: var(--fs-body);\n  }\n  .abyb__q-text p {\n    font-size: var(--fs-body);\n  }\n  .abyb__q {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .abyb__note p {\n    font-size: var(--fs-body);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
